<template>
<div>

  <Drawer v-model="formDialog" :mask-closable="false" width="880" @on-close="closeDialog">
    <div slot="header"><strong>{{lrId?'Edit':'Add'}} LR</strong></div>
    <div slot="close">
      <Button type="error" v-if="lrId&&isAdmin&&lrStatus==='Performa'" @click.stop="onChangeLRStatus">Cancel LR</Button>
      <Icon size="20" class="close-icon" type="md-close" @click="closeDialog"/></div>
    <div class="drawer-body">
      <Form :model="form" :rules="ruleForm" ref="form" label-position="top">
        <Row :gutter="12" type="flex" justify="space-between">
          <Col span="12" class="fs-16">
            <div>#{{form.lrNumber}}</div>
            <div v-if="order">{{roughtOfOrder(order)}}</div>
            <div v-if="order">{{order.orderNumber}}</div>
          </Col>
          <Col span="12" class="fs-16" style="text-align: end">
            <div :style="'color:'+lrStatusColor[lrStatus]">{{lrStatus}}</div>
            <div v-if="order">{{order.clientobject.name}}</div>
            <div v-if="order">{{getAddressString(order.clientobject.address[0])}}</div>
          </Col>
          <Divider/>
          <Col span="10" class="mb-16"><h2>Pickup Location</h2></Col>
          <Col span="10" class="mb-16"><h2>Drop Location</h2></Col>
          <Col span="10">
            <Select placeholder="City" class="city-field" v-model="pickupCompanyCity" filterable @on-change="onSelectCity($event, 'pickupCompany')">
              <Option v-for="(item, index) in cities" :value="item" :key="index">{{item}}</Option>
            </Select>
            <FormItem prop="pickupCompanyId" class="content-flex">
              <Select placeholder="Search Pickup Point" v-model="form.pickupCompanyId" filterable clearable
                      @on-query-change="search($event, 'pickupCompanyFilter')" @on-change="onSelectCompany($event, 'pickupCompany')" >
                <Option v-for="(item, index) in pickupCompanyArr" :value="item.id" :key="index">{{ item.name }}</Option>
              </Select> <div class="add-link" @click="addAddressBookCompany">ADD</div>
            </FormItem> <div class="address-str">{{getAddressString(pickupCompanyObj&&pickupCompanyObj.address[0])}}</div>
          </Col>
          <Col span="10">
            <Select placeholder="City" class="city-field" v-model="dropCompanyCity" filterable @on-change="onSelectCity($event, 'dropCompany')">
              <Option v-for="(item, index) in cities" :value="item" :key="index">{{item}}</Option>
            </Select>
            <FormItem prop="dropCompanyId" class="content-flex">
              <Select placeholder="Search Drop Point" v-model="form.dropCompanyId" filterable clearable
                      @on-query-change="search($event, 'dropCompanyFilter')" @on-change="onSelectCompany($event, 'dropCompany')" >
                <Option v-for="(item, index) in dropCompanyArr" :value="item.id" :key="index">{{ item.name }}</Option>
              </Select> <div class="add-link" @click="addAddressBookCompany">ADD</div>
            </FormItem> <div class="address-str">{{getAddressString(dropCompanyObj&&dropCompanyObj.address[0])}}</div>
          </Col>
          <Col span="10" style="margin: 18px 0 0 0"><address-form ref="pickup-address"/></Col>
          <Col span="10" style="margin: 18px 0 0 0"><address-form ref="drop-address"/></Col>

          <Divider/>
          <Col span="10" class="mb-16"><h2>Consignor</h2></Col>
          <Col span="10" class="mb-16"><h2>Consignee</h2></Col>
          <Col span="10">
            <Select placeholder="City" class="city-field" v-model="consignorCity" filterable @on-change="onSelectCity($event, 'consignor')">
              <Option v-for="(item, index) in cities" :value="item" :key="index">{{item}}</Option>
            </Select>
            <FormItem prop="consignorId" class="content-flex">
              <Select placeholder="Search Consignor" v-model="form.consignorId" filterable clearable
                      @on-query-change="search($event, 'consignorFilter')" @on-change="onSelectCompany($event, 'consignor')" >
                <Option v-for="(item, index) in consignorArr" :value="item.id" :key="index">{{ item.name }}</Option>
              </Select> <div class="add-link" @click="addAddressBookCompany">ADD</div>
            </FormItem> <div class="address-str">{{getAddressString(consignorObj&&consignorObj.address[0])}}</div>
          </Col>
          <Col span="10">
            <Select placeholder="City" class="city-field" v-model="consigneeCity" filterable @on-change="onSelectCity($event, 'consignee')">
              <Option v-for="(item, index) in cities" :value="item" :key="index">{{item}}</Option>
            </Select>
            <FormItem prop="consigneeId" class="content-flex">
              <Select placeholder="Search Consignee" v-model="form.consigneeId" filterable clearable
                      @on-query-change="search($event, 'consigneeFilter')" @on-change="onSelectCompany($event, 'consignee')">
                <Option v-for="(item, index) in consigneeArr" :value="item.id" :key="index">{{ item.name }}</Option>
              </Select> <div class="add-link" @click="addAddressBookCompany">ADD</div>
            </FormItem> <div class="address-str">{{getAddressString(consigneeObj&&consigneeObj.address[0])}}</div>
          </Col>

        </Row><Divider/>
        <Col span="24">
          <FormItem prop="transportVehicle" label="Transport Vehicle" class="content-flex">
            <Select placeholder="Select Vehicle" v-model="form.transportVehicle" clearable style="width: 200px">
              <Option value="LOCAL VEHICLE" v-show="order&&order.orderDetails.pickupVehicleAssignId">Local Vehicle</Option>
              <Option value="TRANSPORT VEHICLE" v-show="order&&order.orderDetails.transportVehicleAssignId">Transport Vehicle</Option>
            </Select><div style="margin: 0 0 0 8px" v-if="order"> {{getVehicleDetails(order, form.transportVehicle, 'platNo')}}</div>
          </FormItem>
        </Col>
        <template v-if="order">
        <Col span="8"><div class="detail-label">Material Details</div><div class="detail-value">{{order.materials.type}} ({{order.materials.boxes}})</div></Col>
        <Col span="8"><div class="detail-label">Size</div><div class="detail-value">{{order.orderDetails.materialSize}}</div></Col>
        <Col span="8"><div class="detail-label">Weight</div><div class="detail-value">{{order.materials.kg}} kg</div></Col>
        <Col span="8"><div class="detail-label">Amount</div><div class="detail-value">As Per Invoice</div></Col>
       <!-- <Col span="8"><div class="detail-label">Transport Vehicle</div>
          <div class="detail-value">{{order.orderDetails.truckOrder?order.orderDetails.truckOrder.truck.platNo:'-'}}</div>
        </Col> -->
        <Col span="8"><div class="detail-label">Truck Driver</div>
          <div class="detail-value">{{order.orderDetails.truckOrder?(order.orderDetails.truckOrder.driverDetail.name+'('+order.orderDetails.truckOrder.driverDetail.mobile+')'):'-'}}</div>
        </Col>
        </template>
      </Form>
    </div>
    <div class="drawer-footer">
<!--  <Button class="save-btn" type="primary" size="large" @click="handleSubmit" :loading="formLoading">Save</Button>  -->
      <Dropdown @on-click="handleSubmit" trigger="click">
        <Button type="primary" :loading="formLoading">SAVE<Icon type="ios-arrow-down"/></Button>
        <DropdownMenu slot="list">
          <DropdownItem>Save</DropdownItem>
          <DropdownItem name="1">Save & Print (Single)</DropdownItem>
          <DropdownItem name="3">Save & Print (Full)</DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <Button class="cancel-btn" size="large" @click="closeDialog">Cancel</Button>
    </div>
    <!-- <Spin size="large" fix></Spin> -->
  </Drawer>

  <register-company-drawer ref="register-company"/>
</div>
</template>

<script>
import {Constants, generateUUID} from "../../Constants/Constant";
import moment from 'moment';
import {GET_ORDER_BY_ID_FOR_LR} from "../../graphql/queries/Orders";
import {GET_LAST_LR, GET_LR_BY_ID} from "../../graphql/queries/lr";
import {incrementAlphaNumericString} from "../../util/helpers";
import {generate_SEARCH_COMPANY, GET_COMPANY_BY_ID} from "../../graphql/queries/companies";
import {getAddressString} from "../ExcelFormattedOrders/RendererFunctions";
import {roughtOfOrder} from "../ExcelFormattedOrders/Settings";
import {getLRStatus, lrStatusColor, getVehicleDetails} from "./Settings";
import RegisterCompanyDrawer from "../RegisterCompanyDrawer";
import AddressForm from "../Common/AddressForm";
import ValidationRules from "../../Constants/ValidationRules";
import {CREATE_UPDATE_LR} from "../../graphql/mutations/lr";
import {generate_UPDATE_ORDER_DATA} from "../../graphql/mutations/orders";
let user = JSON.parse(localStorage.getItem('tatkalorri')).userObj.user
let form = { id:null, pickupAddressId:null, dropAddressId:null,  lrNumber:'TLR2100001', consignorId:null, consigneeId:null,
             pickupCompanyId:null, dropCompanyId:null, transportVehicle: null, createdBy:user.id, updatedBy:user.id }
let sArr = [{name: 'consignor'}, {name: 'consignee'}, {name: 'pickupCompany'}, {name: 'dropCompany'}], sObj = {};
sArr.forEach(s => {
  sObj[s.name+'Arr'] = {
    query() { return generate_SEARCH_COMPANY(s.name) },
    debounce: 500, fetchPolicy: 'network-only',
    variables() { return { search:'%' + this[s.name+'Filter'] + '%', city:[{city: this[s.name+'City']}] }},
  };
})
export default {
  name: "LRForm",
  components: {AddressForm, RegisterCompanyDrawer},
  props: ['formDialog', 'lrId', 'orderId'],
  /*Fetch orderDetails on formDialog value */
  /*Fetch lrDetails on lrId, set form.id*/
  apollo:{
    orders: {
      query: GET_ORDER_BY_ID_FOR_LR,
      fetchPolicy: 'network-only',
      skip () {return !this.formDialog},
      variables(){ return{ id: this.orderId } },
      result ({data}) { this.afterFetchingOrder(data.orders[0]) }
    },
    lr: {
      query: GET_LR_BY_ID,
      fetchPolicy: 'network-only',
      skip () {return !this.lrId},
      variables(){ return{ id: this.lrId } },
      result ({data}) { this.afterFetchingLR(data.lr[0]) }
    },
    ...sObj,
  },
  data(){
      return{
        Constants: Constants,
        moment: moment,
        form: {...form},
        ruleForm: { pickupCompanyId: ValidationRules.selectField, dropCompanyId: ValidationRules.selectField,
                    consignorId: ValidationRules.selectField, consigneeId: ValidationRules.selectField },
        order: null,
        lr: null,
        /* consignorArr: [], consignorFilter: null, consignorObj: null, consignorCity: '', */
        ...sArr.reduce((ac, s) => {ac[s.name+'Arr'] = []; ac[s.name+'Filter'] = ''; ac[s.name+'Obj'] = null; ac[s.name+'City'] = ''; return ac}, {}),
        getAddressString, lrStatusColor, roughtOfOrder, getVehicleDetails,
        editCompanyDrawer: false,
        addToAddressBookOnly: true,
        formLoading: false,
        cities: []                         //Array of pickup, drop & client cities
      }
  },
  computed:{
    isAdmin: function(){ return this.$store.state.userObj.role[0].id === Constants.adminRoleId },
    lrStatus(){ return this.lr&&this.order?getLRStatus(this.lr, this.order):'Performa' }
  },
  methods:{
    search(val, model){                                          //For consignor, consignee
      if(val?.length > 1) this[model] = val
    },
    onSelectCompany(val, type){
        this[type+'Obj'] = this[type+'Arr'].filter(c => c.id === val)[0]
        this.fillAddress(this[type+'Obj'], type)
    },
    fillAddress(companyObj, type){
      if(type === 'pickupCompany' && companyObj) this.$refs['pickup-address'].modifyAddressAndSetForm(companyObj.address[0])
      if(type === 'dropCompany' && companyObj) this.$refs['drop-address'].modifyAddressAndSetForm(companyObj.address[0])
    },
    onSelectCity(val, type){
      this.form[type+'Id'] = '';
      this[type+'Filter'] = '';
    },
    afterFetchingOrder(order){
      this.order = order;
      this.getLrNumber();
      let city = order.clientobject.address[0].city;
      if(!this.cities.includes(city)) this.cities.push(city);
      if(!this.lrId) {
        this.getCompanyById(order.orderDetails.pickupPoint.pickupPartyId || order.pickuppartyid, 'consignor')
        this.getCompanyById(order.orderDetails.pickupPoint.pickupPartyId || order.pickuppartyid, 'pickupCompany')
        this.getCompanyById(order.orderDetails.dropPoint.dropPartyId || order.droppingpartyid, 'consignee')
        this.getCompanyById(order.orderDetails.dropPoint.dropPartyId || order.droppingpartyid, 'dropCompany')
        this.$refs['pickup-address'].modifyAddressAndSetForm(order.orderDetails.pickupPoint.pickupPartyId ? order.orderDetails.pickupPoint : order.pickuppartyobject.address[0])
        this.$refs['drop-address'].modifyAddressAndSetForm(order.orderDetails.dropPoint.dropPartyId ? order.orderDetails.dropPoint : order.droppingpartyobject.address[0])
      }
    },
    afterFetchingLR(lr){
      this.lr = lr;
      Object.copyExistingKeys(this.form, lr)
      this.getCompanyById(lr.consignorId, 'consignor')
      this.getCompanyById(lr.pickupCompanyId, 'pickupCompany')
      this.getCompanyById(lr.consigneeId, 'consignee')
      this.getCompanyById(lr.dropCompanyId, 'dropCompany')
      this.$refs['pickup-address'].setForm(lr.PickupAddress)
      this.$refs['drop-address'].setForm(lr.DropAddress)
    },
    async getCompanyById(id, type){
      let response = await this.$apollo.query({
        query: GET_COMPANY_BY_ID,
        variables: { id },
        fetchPolicy: 'network-only',
      })
      this.form[type+'Id'] = id;                                                //this.form.consignorId
      this[type+'Arr'] = response.data.company                                  //this.consignorArr
      this[type+'Obj'] = response.data.company[0]                               //this.consignorObj
      let city = response.data.company[0].address[0].city
      this[type+'City'] = city                                                  //this.consignorCity
      if(!this.cities.includes(city)) this.cities.push(city)
    },
    addAddressBookCompany(){
      this.$refs['register-company'].companyType_skip = false;
      this.editCompanyDrawer = true;
    },
    async getLrNumber(){
      if(this.lrId) return                          //Avoid calling when edit LR
      let res = await this.$apollo.query({
          query: GET_LAST_LR,
          variables:{ startDate: moment().format('YYYY-01-01T00:00:00+05:30') },
          fetchPolicy: "network-only"
      })
      if(res.data.lr.length) this.form.lrNumber = incrementAlphaNumericString(res.data.lr[0].lrNumber);
      else this.form.lrNumber = 'TLR'+moment().format('YY')+'00001'
    },
    async handleSubmit(numOfCopy){
      let p1 = this.$refs['form'].validate()
      let p2 = this.$refs['pickup-address'].validateForm()
      let p3 = this.$refs['drop-address'].validateForm()
      let arr = await Promise.all([p1, p2, p3]);
      if(!arr.includes(false)) this.saveLr(numOfCopy)
    },
    async saveLr(numOfCopy){
      this.formLoading = true;
      await this.getLrNumber();
      ['id', 'pickupAddressId', 'dropAddressId'].forEach(key => this.form[key] = this.form[key]||generateUUID());
      let address = [{...this.$refs['pickup-address'].getForm(), id:this.form.pickupAddressId},{...this.$refs['drop-address'].getForm(), id:this.form.dropAddressId}]
      this.$apollo.mutate({
        mutation: CREATE_UPDATE_LR,
        variables: {
          lr: {...this.form, orderId: this.order.id},
          updateColumns: ['consignorId', 'consigneeId', 'pickupCompanyId', 'dropCompanyId', 'transportVehicle', 'updatedBy'],
          address: address.map(a => ({...a, lrId:this.form.id, createdBy:user.id, updatedBy:user.id})),
          updateColumnsAddress: [...Object.keys(address[0]), 'updatedBy']
        }
      }).then(response => {
        this.formLoading = false;
        this.$Message.success('LR saved successfully!');
        if(numOfCopy) window.open(`${Constants.api_url}performaLRPdf/${this.form.id}/${numOfCopy}/${this.lrStatus}`, '_blank')
        this.closeDialog()
      }).catch(err => {                 //When fail due to lrNumber Uniqueness
        this.formLoading = false;
        if(err.networkError.result.errors[0]?.extensions.code === 'constraint-violation')
          this.$Notice.error({title: 'Request Fails', desc: 'Duplicate LR Number issue, Please try again'});
      })
    },
    onChangeLRStatus(){
      this.$Modal.confirm({
        title: 'Confirmation',
        content: `<p>Are you sure want to cancel status of LR ?</p>`,
        loading: true,
        onOk: async () => {
          let obj = {status: 'INACTIVE'}
          await this.updateRecord(this.lrId, obj, 'lr')
          this.$Message.success('LR canceled successfully!')
          this.$Modal.remove();
          this.closeDialog()
        },
        onCancel: () => console.log('canceled')
      });
    },
    async updateRecord(id, obj, table){
      let response = await this.$apollo.mutate({
        mutation: generate_UPDATE_ORDER_DATA(table),
        variables: { id: id, obj: obj}
      })
      if(response.data) return Promise.resolve(response.data)
    },
    closeDialog(){
      this.$refs['form'].resetFields();
      this.form = {...form};
      this.lr = null;
      this.cities = [];
      this.$refs['pickup-address'].resetForm();
      this.$refs['drop-address'].resetForm();
      this.$emit('update:lrId', null);
      this.$emit('update:formDialog', false)
    }
  }
}
</script>

<style scoped>
.close-icon{
  padding: 4px 8px 4px 50px;
  color: #999
}
.fs-16{
  font-size: 16px;
  /*margin: 0 0 16px 0;*/
}
.mb-16{
  margin-bottom: 16px;
}
.city-field{
  margin-bottom: 12px;
  width: 50%;
}
/deep/ .content-flex .ivu-form-item-content{
  display: flex;
}
.add-link{
  margin-left: 10px;
  text-decoration: underline;
  font-size: 12px;
  cursor: pointer;
}
.address-str{
  margin: -20px 0 0 0;
}
.drawer-body{
  margin-bottom: 300px;
}
.drawer-footer{
  position: fixed;
  bottom: 20px;
  width: 100%;
  background: #fff;
  border-top: 1px solid #e8eaec;
  padding: 12px;
  margin: 0 0 -20px -16px;
}
.save-btn{
  margin: 0 0 0 10px;
}
.cancel-btn{
  background: #999999;
  color: white;
  margin: 0 0 0 10px;
}
.detail-label{
  font-size: 15px;
}
.detail-value{
  font-size: 16px;
  margin: 0 0 18px 0;
  color: #202020;
}
</style>
